import { graphql } from '../../gql';

export const GET_ORDER_QUERY = graphql(`
  query GetFulfillSellerOrderQuery($id: ID!) {
    sellerOrder(id: $id) {
      id
      idAlias
      orderDate
      orderFee
      total
      totalFees
      totalProductFees
      totalPayout
      payout {
        id
        idAlias
        payoutDate
        transaction {
          ... on PayoutTransactionStripe {
            transactionId
            to {
              bankName
              accountName
              last4Digits
              amount
              currencyCode
            }
          }
          ... on PayoutTransactionManual {
            reference
            to {
              note
              type
              amount
              currencyCode
            }
          }
        }
      }
      customer {
        firstName
        lastName
        email
        phone
        shippingAddress {
          address1
          address2
          city
          country
          countryCode
          company
          name
          province
          provinceCode
          zip
        }
      }

      shippingCommission {
        percentage
        amount
      }
      items {
        productId
        productIdAlias
        sku
        title
        productThumbnail
        featuredImage {
          thumbnailUrl
          altText
        }
        total
        totalFees
        unitPrice
        quantity
        weight
        weightUnit
        productVariantOptions {
          name
          value
        }
        productCommission {
          percentage
          amount
        }
        productFee
      }
      status

    }
  }
`);

export const FULFILL_ORDER_MUTATION = graphql(`
  mutation FulfillSellerOrderMutation($id: ID!, $details: FulfillmentDetailsInput!) {
    fulfillSellerOrder(id: $id, details: $details) {
      id
      idAlias
      orderDate
      orderFee
      total
      totalFees
      totalProductFees
      totalPayout
      payout {
        id
        idAlias
        payoutDate
        transaction {
          ... on PayoutTransactionStripe {
            transactionId
            to {
              bankName
              accountName
              last4Digits
              amount
              currencyCode
            }
          }
          ... on PayoutTransactionManual {
            reference
            to {
              note
              type
              amount
              currencyCode
            }
          }
        }
      }
      customer {
        firstName
        lastName
        email
        phone
        shippingAddress {
          address1
          address2
          city
          country
          countryCode
          company
          name
          province
          provinceCode
          zip
        }
      }

      shippingCommission {
        percentage
        amount
      }
      items {
        productId
        title
        total
        totalFees
        unitPrice
        quantity
        productCommission {
          percentage
          amount
        }
        productFee
      }
      status

    }
  }
`);

